<template>
  <div class="detail">
    <div class="header">
      <div class="left" @click="toIndex()">< 返回</div>
      <div class="span1">新建机构</div>
      <div class="right"></div>
    </div>
    <div class="main">
      <el-form
        :inline="false"
        ref="rulesForm"
        :rules="rules"
        :model="queryParams"
        label-width="125px"
      >
        <span>账号信息</span>
        <el-form-item
          label="联系人姓名"
          style="margin-top: 20px"
          prop="user_name"
        >
          <el-input
            v-model="queryParams.user_name"
            placeholder="请输入"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item
          label="身份证号"
          style="margin-top: 20px"
          prop="user_idcard"
        >
          <el-input
            v-model="queryParams.user_idcard"
            placeholder="请输入"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" style="margin-top: 20px" prop="user_email">
          <el-input
            v-model="queryParams.user_email"
            placeholder="请输入"
            style="width: 200px"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="手机号" style="margin-top: 20px" prop="user_phone">
          <el-input
            v-model="queryParams.user_phone"
            placeholder="请输入"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <span>机构主体信息</span>
        <el-form-item label="机构名称" style="margin-top: 20px" prop="org_name">
          <el-input
            v-model="queryParams.org_name"
            placeholder="请输入"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="机构地址" prop="selectedOptions">
          <el-select
            style="margin-right: 10px;width:200px"
            v-model="address.proviceCode"
            @change="handleProviceChange"
            clearable
            filterable
            placeholder="请选择省"
          >
            <el-option
              v-for="item in proviceList"
              :key="item.area_code"
              :label="item.area_name"
              :value="item.area_code"
            >
            </el-option>
          </el-select>
          <el-select
            style="margin-right: 10px;width:200px"
            v-model="address.cityCode"
            @change="handleCityChange"
            clearable
            filterable
            placeholder="请选择市"
          >
            <el-option
              v-for="item in cityList"
              :key="item.area_code"
              :label="item.area_name"
              :value="item.area_code"
            >
            </el-option>
          </el-select>
          <el-select
            style="width:200px"
            v-model="address.areaCode"
            @change="handleAreaChange"
            clearable
            filterable
            placeholder="请选择区"
          >
            <el-option
              v-for="item in areaList"
              :key="item.area_code"
              :label="item.area_name"
              :value="item.area_code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="org_address">
          <el-input
            v-model="queryParams.org_address"
            placeholder="请输入详细地址"
            style="width: 620px"
          ></el-input>
        </el-form-item>
        <el-form-item label="法人姓名" prop="school_legal_person_name">
          <el-input
            v-model="queryParams.school_legal_person_name"
            placeholder="请输入"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="机构电话" prop="org_telephone">
          <el-input
            v-model="queryParams.org_telephone"
            placeholder="请输入"
            style="width: 200px"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="执照代码" prop="org_social_credit_code">
          <el-input
            v-model="queryParams.org_social_credit_code"
            placeholder="请输入"
            style="width: 200px"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <footer>
      <el-button
        style="width: 120px"
        type="primary"
        size=""
        autofocus
        :disabled="!checked"
        @click="save()"
      >
        {{ saveText }}
      </el-button>
      <el-button
        style="margin-left: 20px; width: 120px"
        size=""
        @click="toIndex()"
        >取消</el-button
      >
    </footer>
    <div class="red">
      <el-checkbox v-model="checked"
        >允许机构在未备案状态下上传课程</el-checkbox
      >
    </div>
    <div class="say">
      <p>说明:</p>
      <p>1.创建后可以使用管理员手机号登录</p>
      <p>2.新用户的初始密码为手机号</p>
      <p>3.旧用户的密码不变</p>
    </div>
  </div>
</template>
<script>
import { createOrg, getNextAreaInfo } from "@/api/user/userCenter";
import { regionData, CodeToText } from "element-china-area-data";
import {
  validatePhone,
  validateIdNo,
  validateEMail,
  validateIdcard,
  validatePhoneTwo,
} from "@/utils/validate.js";
import VDistpicker from "v-distpicker";
import _ from "lodash";
export default {
  // props: ["info"],
  components: { VDistpicker },
  data() {
    return {
      saveText: "保存",
      proviceList: [], //省列表数据
      cityList: [], //市列表数据
      areaList: [], //区列表数据
      address: {
        proviceCode: "",
        proviceName: "",
        cityCode: "",
        cityName: "",
        areaCode: "",
        areaName: "",
      }, //覆盖区域控件选择的地址
      queryParams: {
        org_name: "",
        school_legal_person_name: "",
        org_telephone: "",
        org_social_credit_code: "",
        org_address: "",
        province_code: "",
        city_code: "",
        area_code: "",
        user_name: "",
        user_phone: "",
        user_email: "",
        user_idcard: "",
        // selectedOptions: [],
      },
      options: regionData,
      checked: false,
      disabled: false,
      rules: {
        user_name: [
          { required: true, message: "请输入管理员姓名", trigger: "blur" },
        ],
        user_idcard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { validator: validateIdNo, trigger: "blur" },
        ],
        user_email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: validateEMail, trigger: "blur" },
        ],
        user_phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
        // selectedOptions: [
        //   { required: true, message: "请选择机构地址", trigger: "blur" },
        // ],
        org_name: [
          { required: true, message: "请输入机构名称", trigger: "blur" },
        ],
        org_address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        school_legal_person_name: [
          { required: true, message: "请输入法人姓名", trigger: "blur" },
        ],
        org_telephone: [
          { required: true, message: "请输入机构电话", trigger: "blur" },
          { validator: validatePhoneTwo, trigger: "blur" },
        ],
        org_social_credit_code: [
          { required: true, message: "请输入执照代码", trigger: "blur" },
          { validator: validateIdcard, trigger: "blur" },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    // this.initData();
  },
  methods: {
    save: _.throttle(
     async function () {
        this.saveText = "正在提交...";
        let _queryParams = this.queryParams;
        let params = {
          org_name: _queryParams.org_name, //	机构名称，长度限制为1~64个字符，字母、数字、汉字、下划线_
          usession_id: sessionStorage.getItem("usessionid"), //	操作者用户会话
          org_type: "8", //	2学校、8企业机构、9教学工作室
          org_telephone: _queryParams.org_telephone, //	学校、企业的联系电话，未传递时默认使用操作者绑定的手机号，如果操作者未绑定手机号，则这里必须填写（如果数据来源是系统生成的则忽略此限制）
          source: "0", //  数据来源，0:普通注册, 1:系统生成,2后台导入
          org_category: "2", //  所属类别，默认0，详细见十三.4
          school_legal_person_name: _queryParams.school_legal_person_name, //	法人代表姓名 420281199111111297
          org_social_credit_code: _queryParams.org_social_credit_code, //	组织统一执照代码17位  20196110022026727
          // org_code_certificate: _queryParams.org_social_credit_code,
          org_address: _queryParams.org_address, //	组织的联系地址  13034496534
          // province_code: _queryParams.selectedOptions[0], //	地理省份
          // city_code: _queryParams.selectedOptions[1], //	地理城市
          // area_code: _queryParams.selectedOptions[2], //	地理区域
          province_code: this.address.proviceCode, //	地理省份
          city_code:
            this.address.cityCode == undefined ? "" : this.address.cityCode, //	地理城市
          area_code:
            this.address.areaCode == undefined ? "" : this.address.areaCode, //	地理区域
          org_record_status: "", //	教育局备案状态,0:未备案，1：已备案
          // org_source_level: "", //	企业来源等级，1：教育部，2：区级
          // org_source_name: "", //	企业来源名称， 教育部，武昌教育局
          org_resource_id: sessionStorage.getItem("orgId"),
          org_parent_id: sessionStorage.getItem("orgId"),
          user_name: _queryParams.user_name,
          user_phone: _queryParams.user_phone,
          user_email: _queryParams.user_email,
          user_idcard: _queryParams.user_idcard,
        };
        this.$refs["rulesForm"].validate(async (valid) => {
          if (valid) {
            // console.log('创建机构参数---',params);
            const { code, message } = await createOrg(params);
            if (code === "000000") {
              this.$message({
                type: "success",
                message: "添加成功",
              });
              this.toIndex();
            } else if (code === "100004") {
              this.$message({
                type: "error",
                message: "该邮箱已绑定了其他管理员账号",
              });
            } else if (code === "100005") {
              this.$message({
                type: "error",
                message: "该身份证号已绑定了其他管理员账号",
              });
            } else {
              this.$message({
                type: "error",
                message: message || "提交失败",
              });
              this.saveText = "保存";
            }
          } else {
            this.$message({
              type: "error",
              message: "请输入必填项!",
            });
          }
        });
      },
      3000,
      { leading: true, trailing: false }
    ),
    toIndex() {
      this.$emit("to-index");
      for (let k in this.queryParams) {
        this.queryParams[k] = "";
      }
    },
    initData() {
      // 用户中心获取全部省的数据
      getNextAreaInfo({ area_code: "0" }).then((res) => {
        if (res.code == "000000") {
          this.proviceList = res.result;
        }
      });
    },
    async handleProviceChange(areaCode) {
      var obj = {};
      obj = this.proviceList.find(function (item) {
        return item.area_code === areaCode;
      });
      this.address.proviceName = obj.area_name;
      const { code, result } = await getNextAreaInfo({ area_code: areaCode });
      if (code == "000000") {
        this.cityList = result;
      }
      this.address.cityCode = "";
      this.address.cityName = "";
      this.address.areaCode = "";
      this.address.areaName = "";
    },
    async handleCityChange(areaCode) {
      var obj = {};
      obj = this.cityList.find(function (item) {
        return item.area_code === areaCode;
      });
      this.address.cityName = obj.area_name;
      const { code, result } = await getNextAreaInfo({ area_code: areaCode });
      if (code == "000000") {
        this.areaList = result;
      }
      this.address.areaCode = "";
      this.address.areaName = "";
    },
    async handleAreaChange(areaCode) {
      var obj = {};
      obj = this.areaList.find(function (item) {
        return item.area_code === areaCode;
      });
      this.address.areaName = obj.area_name;
    },
  },
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
  }
  .main {
    width: 100%;
    height: 100%;
    // margin-top: 80px;
    padding-left: 10%;
    span {
      font-size: 15px;
      font-weight: 700;
      margin-bottom: 30px;
    }
    .main-title {
      display: flex;
      align-items: center;
      p {
        font-weight: bold;
        font-size: 14px;
        color: #181c26;
        margin-left: 10px;
      }
    }
    .input-list {
      display: flex;
      align-items: flex-start;
      margin-top: 10px;
      p {
        width: 90px;
        line-height: 21px;
        font-size: 14px;
        color: #606266;
      }
    }
  }
  footer {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }
  .Homeboxtop_nav_tab {
    span {
      width: 100px;
      font-weight: 400;
      font-size: 15px;
      margin-right: 40px;
      cursor: pointer;
      padding-bottom: 15px;
    }
    .active {
      color: #4991e1;
      border-bottom: 3px solid #4991e1;
    }
  }
  .table {
    width: 100%;
    margin-top: 30px;
    border: 1px solid #eee;
    .td-1 {
      width: 30%;
      display: inline-block;
      position: relative;
      top: -8px;
    }
    .td-2 {
      width: 70%;
      display: inline-block;
    }
    .file {
      display: flex;
      align-items: center;
      justify-content: space-between;
      div {
        display: flex;
        align-items: center;
        img {
          margin-right: 20px;
        }
        span {
          width: 200px;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      a {
        font-size: 14px;
        line-height: 48px;
        color: #4991e1;
        margin-right: 20px;
      }
    }
    li {
      display: inline-block;
      width: 50%;
      height: 100%;
      text-align: center;
      font-size: 14px;
      line-height: 48px;
      color: #7a8da2;
      position: relative;
    }
    .table-header {
      width: 100%;
      height: 48px;
      background: #fafafa;
      border: 1px solid #eee;
      display: flex;
      div {
        height: 100%;
        text-align: center;
        font-size: 14px;
        line-height: 48px;
        color: #7a8da2;
      }
    }
  }
  .table_2_tr {
    font-size: 14px;
    line-height: 48px;
    color: #7a8da2;
    text-align: center;
  }
}
.red {
  margin: 40px;
  text-align: center;
}
.say {
  margin-top: 30px;
  margin-left: 10%;
  color: #606266;
  p {
    margin: 15px;
  }
}
::v-deep .el-form .el-input__inner {
  // width: 300px;
  height: 32px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}
</style>
<style>
.distpicker-address-wrapper select {
  height: 35px;
  width: 164px;
}
</style>
